import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Badge } from "@/components/ui/badge";
import { MapPin } from "lucide-react";
import usePullToRefresh from "@/hooks/usePullToRefresh";
import PullIndicator from "@/components/PullIndicator";

export default function MyTasks() {
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);
  const load = () => api.get("/tasks/mine").then(({ data }) => setTasks(data));
  useEffect(() => { load(); }, []);
  const { pullY, progress, isRefreshing } = usePullToRefresh(load);

  const statusStyles = {
    open: "bg-blue-50 text-blue-700 border-blue-200",
    assigned: "bg-amber-50 text-amber-700 border-amber-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    paid: "bg-emerald-100 text-emerald-800 border-emerald-300",
  };

  return (
    <div className="space-y-6">
      <PullIndicator pullY={pullY} progress={progress} isRefreshing={isRefreshing} />
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">
        {user?.role === "local" ? "My tasks" : "My jobs"}
      </h1>
      {tasks.length === 0 ? (
        <div className="text-center py-16 text-slate-500">Nothing here yet.</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {tasks.map((t) => (
            <Link key={t.task_id} to={`/tasks/${t.task_id}`} data-testid={`mytask-${t.task_id}`} className="bg-white border border-slate-200/80 rounded-2xl p-5 card-hover">
              <div className="flex items-center justify-between gap-3">
                <Badge className={statusStyles[t.status] + " capitalize"}>{t.status}</Badge>
                <div className="font-mono-money text-sm px-3 py-1 rounded-xl bg-[#3E2A4E] text-[#D9FF3D]">${t.budget}</div>
              </div>
              <h3 className="font-heading font-bold text-lg mt-3">{t.title}</h3>
              <div className="text-xs text-slate-500 mt-2 inline-flex items-center gap-1"><MapPin size={12} /> {t.location}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
